const authUrl = process.env.REACT_APP_TELEM_FRONTEND_AUTH;

export default {
    // called when the user attempts to log in
    login: ({ username, password }) =>  {        
        const url = `${authUrl}/login?username=${username}&password=${password}`;
        const request = new Request(url, {
            method: 'POST',
            // body: JSON.stringify({ username, password }),
            // headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ token }) => {
                // store the token in local storage
                localStorage.setItem('token', 'Bearer ' + token);
                localStorage.setItem('username', username);
                localStorage.setItem('login', 'admin');
                localStorage.setItem('user', 'Admin');
                localStorage.setItem(
                    'avatar',
                    'data:image/jpeg;base64,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'
                );
                return Promise.resolve();
            })
            .catch(() => {
                throw new Error('Network error')
            });
    },

    // called when the user clicks on the logout button
    logout: () => {
        localStorage.removeItem('username');
        localStorage.removeItem('avatar');
        localStorage.removeItem('login');
        localStorage.removeItem('user');
        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            localStorage.removeItem('username');
            localStorage.removeItem('avatar');
            localStorage.removeItem('login');
            localStorage.removeItem('user');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        return localStorage.getItem('username')
            ? Promise.resolve()
            : Promise.reject();
    },
    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: () => {
        return localStorage.getItem('username')
            ? Promise.resolve()
            : Promise.reject();
    },
    getIdentity: () => {
        // localStorage.getItem('username') == null 
        //     ? localStorage.setItem('authenticated', false)
        //     : localStorage.getItem('authenticated');
        return {
            id: localStorage.getItem('login'),
            fullName: localStorage.getItem('user'),
            avatar: localStorage.getItem('avatar'),
        };
    },
};